import { render, staticRenderFns } from "./handSign.vue?vue&type=template&id=6423b45f&scoped=true"
import script from "./handSign.vue?vue&type=script&lang=js"
export * from "./handSign.vue?vue&type=script&lang=js"
import style0 from "./handSign.vue?vue&type=style&index=0&id=6423b45f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6423b45f",
  null
  
)

export default component.exports